export default __webpack_public_path__ + "static/media/1975.4afea527.png";